const getCookieKey = () => {
  return `isLoggedIn${process.env.NODE_ENV !== "production" ? `_${process.env.NODE_ENV}` : ""}`;
};

export const getAuthCookie = () => {
  const cookieTokens = document.cookie.split(";");
  const cookieObject = cookieTokens.reduce((prevObj, token) => {
    const obj = prevObj;
    const tokenPair = token.trim().split("=");
    obj[tokenPair[0]] = tokenPair.length > 1 ? tokenPair[1] : true;
    return obj;
  }, {});
  const cookieKey = getCookieKey();
  if (cookieKey in cookieObject) {
    return JSON.parse(cookieObject[cookieKey]);
  }
  return null;
};

export const setAuthCookie = () => {
  const authObj = { isLoggedIn: true, langCode: process.env.LANG_CODE };
  document.cookie = `${getCookieKey()}=${JSON.stringify(authObj)}; domain=.abcya.com; path=/; Max-Age=${24 * 3600 * 7}`;
};

export const clearAuthCookie = () => {
  const authObj = { isLoggedIn: false, langCode: process.env.LANG_CODE };
  document.cookie = `${getCookieKey()}=${JSON.stringify(authObj)}; domain=.abcya.com; path=/`;
};

export const removeAuthCookie = () => {
  document.cookie = `${getCookieKey()}=; max-age=0; domain=.abcya.com; path=/`;
};
